import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { FlexLayoutModule } from '@angular/flex-layout';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { Injectable } from '@angular/core';
import { ColorPickerModule } from 'ngx-color-picker';
import { ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { getSpanishPaginatorIntl } from './modules/common/helpers/translation/spanish-pagination';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatBadgeModule } from '@angular/material/badge';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTreeModule } from '@angular/material/tree';

@NgModule({
   imports: [
      CommonModule,
      MatButtonModule,
      MatToolbarModule,
      MatIconModule,
      MatSidenavModule,
      MatBadgeModule,
      MatListModule,
      MatGridListModule,
      MatFormFieldModule,
      MatInputModule,
      MatRadioModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatChipsModule,
      MatTooltipModule,
      MatTableModule,
      MatPaginatorModule,
      MatCardModule,
      FlexLayoutModule,
      MatSnackBarModule,
      MatMenuModule,
      MatTabsModule,
      MatDialogModule,
      ColorPickerModule,
      ReactiveFormsModule,
      MatSelectModule,
      MatButtonToggleModule,
      MatSlideToggleModule,
      MatMomentDateModule,
      MatProgressSpinnerModule,
      MatCheckboxModule,
      MatAutocompleteModule,
      MatProgressBarModule,
      MatBottomSheetModule,
      MatDividerModule,
      MatExpansionModule,
      MatRippleModule,
      MatSliderModule,
      MatSortModule,
      MatStepperModule,
      MatTreeModule,
      PdfViewerModule,
   ],
   exports: [
      MatButtonModule,
      MatToolbarModule,
      MatIconModule,
      MatSidenavModule,
      MatBadgeModule,
      MatListModule,
      MatGridListModule,
      MatInputModule,
      MatFormFieldModule,
      MatSelectModule,
      MatRadioModule,
      MatDatepickerModule,
      MatChipsModule,
      MatTooltipModule,
      MatTableModule,
      MatPaginatorModule,
      MatCardModule,
      FlexLayoutModule,
      MatSnackBarModule,
      MatMenuModule,
      MatTabsModule,
      MatDialogModule,
      ReactiveFormsModule,
      MatAutocompleteModule,
      MatInputModule,
      MatButtonModule,
      ColorPickerModule,
      MatButtonModule,
      MatButtonToggleModule,
      MatSlideToggleModule,
      MatProgressSpinnerModule,
      MatCheckboxModule,
      MatProgressBarModule,
      PdfViewerModule,
      MatTreeModule,
      MatSortModule

   ],
   declarations: [],
   providers: [
      MatDatepickerModule,
      {
         provide: MatPaginatorIntl, useValue: getSpanishPaginatorIntl()
     }
   ],
   schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AngularMaterialModule { }
